import { ISetPriorityParams } from '../types/actionParams';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export class SetRunFlowTasksPriorityRequest extends Request<ISetPriorityParams, IResult> {
  constructor(ids: string[], priority: number) {
    super('setRunFlowTasksPriority', {
      ids: ids,
      priority: priority
    });
  }
}
